module.exports = __webpack_public_path__ + "static/media/icon-what-doesn-t-help.37d110ad.svg";